module.exports = __webpack_public_path__ + "static/media/subscribe.f5b4a64e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/subscribe.png
// module id = 768
// module chunks = 0 1